import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const REFERRAL_COOKIE_KEY = 'nathof_referral_code';
const REFERRAL_EXPIRY_DAYS = 7;

export function useReferralCapture() {
  useEffect(() => {
    captureReferralFromUrl();
  }, []);
}

function captureReferralFromUrl() {
  // Check for ref param in URL
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('ref') || urlParams.get('code');

  if (refCode) {
    // Save to localStorage with expiry
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + REFERRAL_EXPIRY_DAYS);

    const referralData = {
      code: refCode,
      capturedAt: new Date().toISOString(),
      expiresAt: expiryDate.toISOString(),
      landingPath: window.location.pathname,
    };

    localStorage.setItem(REFERRAL_COOKIE_KEY, JSON.stringify(referralData));

    // Track the click
    trackReferralClick(refCode, window.location.pathname, document.referrer);

    // Clean URL (remove ref param without reload)
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('ref');
    cleanUrl.searchParams.delete('code');
    window.history.replaceState({}, '', cleanUrl.toString());

    console.log('[Referral] Captured code:', refCode);
  }
}

async function trackReferralClick(code: string, landingPath: string, referrer: string) {
  try {
    await supabase.functions.invoke('referral-click', {
      body: { code, landing_path: landingPath, referrer },
    });
  } catch (error) {
    console.error('[Referral] Failed to track click:', error);
  }
}

export function getReferralCode(): string | null {
  try {
    const stored = localStorage.getItem(REFERRAL_COOKIE_KEY);
    if (!stored) return null;

    const data = JSON.parse(stored);
    
    // Check if expired
    if (new Date(data.expiresAt) < new Date()) {
      localStorage.removeItem(REFERRAL_COOKIE_KEY);
      return null;
    }

    return data.code;
  } catch {
    return null;
  }
}

export function clearReferralCode() {
  localStorage.removeItem(REFERRAL_COOKIE_KEY);
}

export function getReferralData(): { code: string; capturedAt: string; expiresAt: string; landingPath: string } | null {
  try {
    const stored = localStorage.getItem(REFERRAL_COOKIE_KEY);
    if (!stored) return null;

    const data = JSON.parse(stored);
    
    // Check if expired
    if (new Date(data.expiresAt) < new Date()) {
      localStorage.removeItem(REFERRAL_COOKIE_KEY);
      return null;
    }

    return data;
  } catch {
    return null;
  }
}
